import React from "react";
import { Box, Chip, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

const getTypeColor = (type) => {
  switch (type?.toLowerCase()) {
    case "host":
      return "secondary";
    case "club":
      return "success";
    case "coach":
    default:
      return "primary";
  }
};

const CoachDetailModal = ({ open, onClose, record }) => {
  if (!record) return null;
  const img = record.profileimg || record.coachImage;
  const type = record.type || "coach";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <div className="d-flex justify-content-between align-center p-3">
        <h3>{record.coachName}</h3>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DialogContent dividers>
        {record.coverimage && (
          <Box sx={{ mb: 2, borderRadius: 1, overflow: "hidden", border: "1px solid #ddd" }}>
            <img src={record.coverimage} alt="Cover" style={{ width: "100%", maxHeight: 180, objectFit: "cover", display: "block" }} />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Box sx={{ width: 64, height: 64, borderRadius: "50%", overflow: "hidden", border: "1px solid #ddd", bgcolor: "#f5f5f5", flexShrink: 0 }}>
            {img ? (
              <img src={img} alt={record.coachName || ""} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : null}
          </Box>
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{record.coachName}</Typography>
              <Chip label={type.toUpperCase()} size="small" color={getTypeColor(type)} />
            </Box>
            <Typography variant="body2" color="text.secondary">{record.title || "-"}</Typography>
            <Typography variant="body2" color="text.secondary">{record.location || "-"}</Typography>
          </Box>
        </Box>

        {record.description && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2">Description</Typography>
            <Typography variant="body2">{record.description}</Typography>
          </Box>
        )}

        {Array.isArray(record.credentials) && record.credentials.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Credentials</Typography>
            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
              {record.credentials.map((item, index) => (
                <Chip key={index} label={item} size="small" variant="outlined" />
              ))}
            </Box>
          </Box>
        )}

        {Array.isArray(record.achievements) && record.achievements.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Achievements</Typography>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {record.achievements.map((item, index) => (
                <li key={index}><Typography variant="body2">{item}</Typography></li>
              ))}
            </ul>
          </Box>
        )}

        {Array.isArray(record.amenities) && record.amenities.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Amenities</Typography>
            {record.amenities.map((amenity, index) => (
              <Box key={index} sx={{ mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{amenity.title}</Typography>
                <Typography variant="body2" color="text.secondary">{amenity.description}</Typography>
              </Box>
            ))}
          </Box>
        )}

        {(record.website || record.facebook || record.instagram || record.tiktok) && (
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>Social Links</Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {record.website && <Typography variant="body2">Website: {record.website}</Typography>}
              {record.facebook && <Typography variant="body2">Facebook: {record.facebook}</Typography>}
              {record.instagram && <Typography variant="body2">Instagram: {record.instagram}</Typography>}
              {record.tiktok && <Typography variant="body2">TikTok: {record.tiktok}</Typography>}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CoachDetailModal;